import { Component, Inject, OnInit } from '@angular/core';
import { SqlService } from '../../../Database/sql.service';
import { DOCUMENT } from '@angular/common';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit {
  firstTableData: any[] = [];
  secondTableData: any[] = [];

  loadingFirst = false;
  loadingSecond = false;
  errorFirst: string | null = null;
  errorSecond: string | null = null;

  selectedRowKey: string | null = null;

  constructor(private sql: SqlService, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.loadFirstTable();
  }

  private formatDate(val: any): string {
    if (!val) return '';
    if (typeof val === 'string') {
      const d = new Date(val);
      if (!isNaN(d.getTime())) return d.toLocaleString();
      return val;
    }

    if (typeof val === 'number') {
      const d = new Date(val);
      if (!isNaN(d.getTime())) return d.toLocaleString();
      return String(val);
    }

    if (typeof val === 'object') {
      // common shapes: {date: '...'} or {date: {date: '...'}}
      if ('date' in val) {
        const candidate: any = (val as any).date;
        const d = new Date(candidate);
        if (!isNaN(d.getTime())) return d.toLocaleString();
      }

      try {
        // try to stringify and extract ISO datetime
        const s = JSON.stringify(val);
        const iso = s.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/);
        if (iso) {
          const d = new Date(iso[0]);
          if (!isNaN(d.getTime())) return d.toLocaleString();
        }
      } catch (e) {}

      // fallback to toString
      try {
        const s = (val as any).toString();
        const d = new Date(s);
        if (!isNaN(d.getTime())) return d.toLocaleString();
        return s;
      } catch (e) {
        return String(val);
      }
    }

    return String(val);
  }

  loadFirstTable() {
    this.loadingFirst = true;
    this.errorFirst = null;
    this.sql.getAdminDashboardFirstTable()
      .pipe(finalize(() => this.loadingFirst = false))
      .subscribe((res: any) => {
        this.firstTableData = (res || []).map((r: any, i: number) => ({
          ...r,
          // prefer an existing ID if returned by the API, otherwise create a stable rowId
          rowId: r.ID ? String(r.ID) : ('row_' + i + '_' + (r.iprovider || '') + '_' + (r.itype || '')),
          datetimeFormatted: this.formatDate(r.datetime)
        }));
      }, err => {
        console.error(err);
        this.errorFirst = 'Failed to load dashboard data. Please try again.';
      });
  }

  onSelectRow(row: any) {
    const provider = row.iprovider;
    const type = row.itype;

    // use rowId for selection instead of provider||type
    this.selectedRowKey = row.rowId || null;

    this.loadingSecond = true;
    this.errorSecond = null;
    this.secondTableData = [];

    this.sql.getAdminDashboardSecondTable(provider, type)
      .pipe(finalize(() => this.loadingSecond = false))
      .subscribe((res: any) => {
        this.secondTableData = (res || []).map((r: any, i: number) => ({
          ...r,
          idatetimeFormatted: this.formatDate(r.idatetime),
          rowId: r.ID ? String(r.ID) : ('second_' + i + '_' + (r.iprovider || '') + '_' + (r.itype || ''))
        }));
      }, err => {
        console.error(err);
        this.errorSecond = 'Failed to load details for the selected row. Please try again.';
      });
  }

  isSelected(row: any) {
    if (!row) return false;
    return (row.rowId || '') === (this.selectedRowKey || '');
  }
}
